import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ActualComponent } from './page/actual/actual.component';
import { FinalPackageComponent } from './page/final-package/final-package.component';
import { PlanComponent } from './page/plan/plan.component';
import { SupplementsComponent } from './page/supplements/supplements.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { MsalGuard } from './msal';

const routes: Routes = [
  // { path: 'home', component: ActualComponent, canActivate: [MsalGuard] },
  { path: 'actual', component: ActualComponent, canActivate: [MsalGuard] },
  { path: 'plan', component: PlanComponent, canActivate: [MsalGuard] },
  { path: 'supp', component: SupplementsComponent, canActivate: [MsalGuard] },
  {
    path: 'finalpackage',
    component: FinalPackageComponent,
    canActivate: [MsalGuard],
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: '**', redirectTo: 'actual' },
  { path: 'home', redirectTo: 'actual' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}